import axios from 'axios';
import { useMutation } from 'react-query';

export interface VerifyResponse {
  'success': boolean;
  'error-codes': string[];
  'messages': any[];
}

/**
 * Cloudflare Turnstile siteverify mutation
 */
export const useVerifyTurnstileTokenMutation = () => {
  return useMutation((token: string) => {
    return new Promise<VerifyResponse>((resolve) => {
      axios
        .post<VerifyResponse>('/api/cloudflare/verify', { token })
        .then((response) => resolve(response.data))
        .catch((error) => console.log(error));
    });
  });
};
